import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";

/**
 * Generated class for the WebfleetReportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webfleet-report',
  templateUrl: 'webfleet-report.html',
})
export class WebfleetReportPage {

  title: string = '';
  times: any = {};
  day: number;
  rawData: any = {};
  choosenCostcenter: any = '';
  costCenter: any = {};
  choosenLocation: any = 'Standort / Zuhause';
  lastSelectedCostcenter: any = '';
  coastCenter: any = [
    {id: 10100, title: 'Verwaltung'},
    {id: 10200, title: ' Raumpflege'},
    {id: 10300, title: ' Beteiligungen'},
    {id: 10400, title: ' Umbau Werkstatt Mhg.'},
    {id: 11000, title: ' WB Sonstige'},
    {id: 11200, title: ' WB WHL West'},
    {id: 11230, title: ' WB NVL'},
    {id: 11240, title: ' WB Ohlen иВV.'},
    {id: 11250, title: ' WB WHL Ost'},
    {id: 11500, title: ' WB Barbara'},
    {id: 11550, title: ' WB WMS'},
    {id: 11600, title: ' WB WMSDB'},
    {id: 11610, title: ' WB WOS'},
    {id: 11620, title: ' WB WQS'},
    {id: 11630, title: ' WB RBM'},
    {id: 11640, title: ' WB HTB'},
    {id: 11700, title: ' WB WSD'},
    {id: 11750, title: ' WB BT Beton-Technik'},
    {id: 11800, title: ' WB Dino'},
    {id: 11810, title: ' WB Dino Entwicklung'},
    {id: 11820, title: ' WB Dino Internationa'},
    {id: 330, title: ' WB Wolter Design'},
    {id: 11850, title: ' WB fair ground'},
    {id: 11860, title: ' WB FG Kunststoffmatt'},
    {id: 11880, title: ' WB FW Automobile'},
    {id: 21000, title: ' Handel'},
    {id: 30000, title: ' Fuhrpark'},
    {id: 31001, title: ' Diverse PKW'},
    {id: 31002, title: ' NI-GC 407'},
    {id: 31003, title: ' NI-GC 669'},
    {id: 31004, title: ' NI-FW 35'},
    {id: 31005, title: ' NI-FW 1109'},
    {id: 31006, title: ' NI-FW 3110'},
    {id: 31007, title: ' NI-FW 1701'},
    {id: 31008, title: ' NI-FW 106'},
    {id: 31009, title: ' NI-FW 1003'},
    {id: 31010, title: ' NI-FW 1122'},
    {id: 31011, title: ' NI-FW 1002'},
    {id: 31012, title: ' NI-FW 1004'},
    {id: 31013, title: ' NI-FW 8000'},
    {id: 14 , title: 'Firmenfahrten'},
    {id: 32000, title: ' NI-FW 1000'},
    {id: 32001, title: ' NI-X 565'},
    {id: 33000, title: ' Diverse Anhänger'},
    {id: 33001, title: ' NI-C 653'},
    {id: 33002, title: ' NI-AT 483'},
    {id: 33003, title: ' NI-LK 21'},
    {id: 33004, title: ' Tieflader Müller'},
    {id: 33005, title: ' Kippmulde'},
    {id: 33006, title: ' Anhänger Bunge'},
    {id: 33007, title: ' Stema Anhänger'},
    {id: 33008, title: ' NI-FW 1005'},
    {id: 34000, title: ' div. Wechselbaugerät'},
    {id: 34001, title: ' Nissan Mini Bagger'},
    {id: 34002, title: ' Komatsu Raupe'},
    {id: 34003, title: ' NI-GE 273'},
    {id: 34004, title: ' NI-FW 24'},
    {id: 34005, title: ' Siebanlage Extec'},
    {id: 34006, title: ' NI-FV 468'},
    {id: -1 , title: 'Radlader Liebherr L5'},
    {id: -1 , title: 'Kehrmaschine Amazone'},
    {id: -1 , title: 'Radlader Liebherr L5'},
    {id: -1 , title: 'Radlader Volvo L150F'},
    {id: 34011 , title: 'Demagkompressor SC30'},
    {id: 41000 , title: 'Münchehagen'},
    {id: 41001 , title: 'Oyle'},
    {id: 41002 , title: 'Hagen alt'},
    {id: 41003 , title: 'Windheim'},
    {id: 41004 , title: 'Eilvese'},
    {id: 41005 , title: 'Schneeren'},
    {id: 41006 , title: 'Hagen neu'},
    {id: 41007 , title: 'Hagenburg'},
    {id: 41008 , title: 'Rehburg'},
    {id: 41009 , title: 'Warnstedt'},
    {id: 41010 , title: 'Landesbergen'},
    {id: 41011 , title: 'Schneeren Mühlenfeld'},
    {id: 43001 , title: 'Hann. Str. 13'},
    {id: 43002 , title: 'Hann. Str. 23'},
    {id: 43003 , title: 'Leeser Str. 13/11'},
    {id: 43004 , title: 'Werkstatt MHG'},
    {id: 43005 , title: 'Alte Zollstr.'},
    {id: -1 , title: 'Hann Str. 19/21'},
    {id: 43007 , title: 'Hann. Str. 15'},
    {id: 43008 , title: 'Nienb. Str. 44'},
    {id: 43009 , title: 'Knüelweg'},
    {id: 43010 , title: 'Hauptstr. 26'},
    {id: 43011 , title: 'Wiesenweg'},
    {id: 43012 , title: 'Hagenb. Str. 27'},
    {id: 43013 , title: 'Lange Str. 15'},
    {id: 43014 , title: 'Hauptstr. 24'},
    {id: 43015 , title: 'Hauptstr. 22'},
    {id: 43016 , title: 'Hann. Str. 25/27'},
    {id: 43017 , title: 'Im Dorfe'},
    {id: 43018 , title: 'Hauptstr. 26b'},
    {id: 43019 , title: 'Lager Nienb. Str. 44'},
    {id: 43020 , title: 'Hauptstr. 26a'},
    {id: 51000 , title: 'Baukolonne'},
    {id: 99999 , title: 'Datenübernahme'},
  ];

  constructor(public navCtrl: NavController, public navParams: NavParams, public userProvider: UserProvider, public teamappProvider: TeamappProvider, public alertCtrl: AlertController) {

    let data = this.navParams.get('data');
    let day = this.navParams.get('day');
    console.log(day);
    this.rawData = data;
    this.day = day;
    this.times = data.days[day-1];
    this.title = 'Tagesbericht';
    console.log(this.hasAlreadyManualStart());
    console.log(this.times);
    this.teamappProvider.http_request('action=get_cost_centers', 'webfleet', false).then(data => {
      this.coastCenter = data;
      console.log(data);
    });
    this.teamappProvider.http_request('action=last_selected_costcenter', 'webfleet', false, false).then(data => {
      let tmpLC: any = data;
      this.lastSelectedCostcenter = tmpLC.objectname;
    });
  }


  swipe(event:any) {
    if(event.direction == 2) {
      this.nextDay();
    } else if(event.direction == 4) {
      this.prevDay();
    }
  }
  nextDay() {
    if(this.day < 7) {
      this.day ++;
      this.times = this.rawData.days[this.day-1];
    }
  }
  prevDay() {
    if(this.day > 1) {
      this.day --;
      this.times = this.rawData.days[this.day-1];
    }
  }

  hasAlreadyManualStart() {
    let ret = false;
    if(this.times.works) {
      for(let i = 0;i<this.times.works.length;i++) {
        if(this.times.works[i].pos_type == 'manual_start') {
          return true;
        }
      }
    }
    return false;
  }

  hasAlreadyManualEnd() {
    let ret = false;
    if(this.times.works) {
      for(let i = 0;i<this.times.works.length;i++) {
        if(this.times.works[i].pos_type == 'manual_end') {
          return true;
        }
      }
    }
    return false;
  }

  hasAlreadyManualStartTwo() {
    let ret = false;
    if(this.times.works) {
      for(let i = 0;i<this.times.works.length;i++) {
        if(this.times.works[i].pos_type == 'manual_start_two') {
          return true;
        }
      }
    }
    return false;
  }

  hasAlreadyManualEndTwo() {
    let ret = false;
    if(this.times.works) {
      for(let i = 0;i<this.times.works.length;i++) {
        if(this.times.works[i].pos_type == 'manual_end_two') {
          return true;
        }
      }
    }
    return false;
  }

  addCostCenter() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Kostenstelle einbuchen');

    this.coastCenter.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0)


    for(let i = 0; i<this.coastCenter.length;i++) {
      let checked: boolean = false;
      if(this.lastSelectedCostcenter != '' && this.lastSelectedCostcenter === this.coastCenter[i].name) {
        checked = true;
      }
      if(this.lastSelectedCostcenter == '' && i==0) {
        checked = true;
      }
      alert.addInput({
        type: 'radio',
        label: this.coastCenter[i].name,
        value: this.coastCenter[i].inner,
        checked: checked,
        handler: (data) =>  {
         console.log(data);
        }
      });
    }

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        let costcenter = data;
        let costcenterName = this.getCostcenterName(data);
        let comment_able = this.hasCostcenterComment(data);
        let alert2 = this.alertCtrl.create();
        alert2.setTitle(costcenterName+' Einbuchen');

        alert2.addInput({
          type: 'time',
          label: 'Start der Arbeit',
          value: 'start',
        });
        alert2.addInput({
          type: 'time',
          label: 'Ende der Arbeit',
          value: 'end',
        });

        if(comment_able == 1) {
          alert2.addInput({
            type: 'text',
            placeholder: 'Kommentar / Arbeit',
            value: '',
          });
        }

        alert2.addButton('Abbrechen');
        alert2.addButton({
          text: 'Weiter',
          handler: data => {
            if(comment_able == 0) {
              if(data[0] != 'end' && data[1] != 'start') {
                this.teamappProvider.http_request('action=add_manual&manual_type=costcenter&costcenter='+costcenter+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
                  this.showSuccess('Erfolgreich wurde eingetragen:<br><br><b> '+costcenterName+'<br>'+data[0]+' - '+data[1]+'</b>');
                  this.navCtrl.pop();
                });
              } else {
                this.addCostCenter();
              }
            } else {
              if(data[0] != 'end' && data[1] != 'start' && data[2] != '') {
                this.teamappProvider.http_request('action=add_manual&manual_type=costcenter&costcenter='+costcenter+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1]+'&manual_comment='+data[2], 'webfleet', false).then(res => {
                  this.showSuccess('Erfolgreich wurde eingetragen:<br><br><b> '+costcenterName+'<br>'+data[0]+' - '+data[1]+'</b>');
                  this.navCtrl.pop();
                });
              } else {
                this.addCostCenter();
              }
            }

          }
        });
        alert2.present();
      }
    });
    alert.present();
  }

  /*chooseCostcenter(is_first: boolean) {
    let alert = this.alertCtrl.create();
    alert.setTitle('Kostenstelle wählen');

    for(let i = 0; i<this.coastCenter.length;i++) {
      alert.addInput({
        type: 'radio',
        label: this.coastCenter[i].name,
        value: this.coastCenter[i].inner,
      });
    }

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        this.choosenCostcenter = data;
        if(is_first) {
          this.addLocationStart();
        } else {
          this.addLocationStartTwo();
        }

      }
    });
    alert.present();
  }*/

  addLocationStart() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Start auswählen');

    alert.addInput({
      type: 'radio',
      label: 'Standort / Zuhause',
      value: 'Standort / Zuhause',
    });
    alert.addInput({
      type: 'radio',
      label: 'Unterwegs',
      value: 'Unterwegs',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        this.choosenLocation = data;
        this.startAdd();
      }
    });
    alert.present();
  }

  addLocationStartTwo() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Start auswählen');

    alert.addInput({
      type: 'radio',
      label: 'Standort / Zuhause',
      value: 'Standort / Zuhause',
    });
    alert.addInput({
      type: 'radio',
      label: 'Unterwegs',
      value: 'Unterwegs',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        this.choosenLocation = data;
        this.startAddTwo();
      }
    });
    alert.present();
  }

  addLocationEnd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Ende auswählen');

    alert.addInput({
      type: 'radio',
      label: 'Standort / Zuhause',
      value: 'Standort / Zuhause',
    });
    alert.addInput({
      type: 'radio',
      label: 'Unterwegs',
      value: 'Unterwegs',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        this.choosenLocation = data;
        this.endAdd();
      }
    });
    alert.present();
  }

  addLocationEndTwo() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Ende auswählen');

    alert.addInput({
      type: 'radio',
      label: 'Standort / Zuhause',
      value: 'Standort / Zuhause',
    });
    alert.addInput({
      type: 'radio',
      label: 'Unterwegs',
      value: 'Unterwegs',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        this.choosenLocation = data;
        this.endAddTwo();
      }
    });
    alert.present();
  }

  addTime() {
    console.log("total costcenters: "+this.countCostCenter());
    let alert = this.alertCtrl.create();
    alert.setTitle('Zeiten einbuchen');

    if(!this.hasAlreadyManualStart()) {
      alert.addInput({
        type: 'radio',
        label: 'Arbeitsanfang',
        value: 'start',
      });
    }
    if(!this.hasAlreadyManualEnd()) {
      alert.addInput({
        type: 'radio',
        label: 'Arbeitsende',
        value: 'end',
      });
    }

    if(this.hasAlreadyManualStart() && this.hasAlreadyManualEnd()) {
      if(!this.hasAlreadyManualStartTwo()) {
        alert.addInput({
          type: 'radio',
          label: 'Arbeitsanfang',
          value: 'start_two',
        });
      }
      if(!this.hasAlreadyManualEndTwo()) {
        alert.addInput({
          type: 'radio',
          label: 'Arbeitsende',
          value: 'end_two',
        });
      }
    }


    alert.addInput({
      type: 'radio',
      label: 'Unbezahlte Pause',
      value: 'break',
    });

    alert.addInput({
      type: 'radio',
      label: 'Kostenstelle',
      value: 'costcenter',
    });

    /*alert.addInput({
      type: 'radio',
      label: 'ADR Zuschlag',
      value: 'adr',
    });*/

    alert.addInput({
      type: 'radio',
      label: 'Problemmeldung',
      value: 'problem',
    });

    alert.addInput({
      type: 'radio',
      label: 'Werkstatt',
      value: 'maintance',
    });

    alert.addInput({
      type: 'radio',
      label: 'Wartezeit',
      value: 'waiting',
    });

    alert.addInput({
      type: 'radio',
      label: 'Waschen / Spülen',
      value: 'washing',
    });

    alert.addInput({
      type: 'radio',
      label: 'Übernachtung',
      value: 'sleep',
    });
    alert.addInput({
      type: 'radio',
      label: 'Einarbeitung',
      value: 'help',
    });
    alert.addInput({
      type: 'radio',
      label: 'Anderes',
      value: 'others',
    });



    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data == 'start') {
          this.addLocationStart();
        }

        if(data == 'start_two') {
          this.addLocationStartTwo();
        }

        if(data == 'break') {
          this.breakAdd();
        }

        if(data == 'end') {
          if(this.countCostCenter() == 0) {
            this.alertCostCenter();
          } else {
            this.checkEndBreak();
          }
        }

        if(data == 'end_two') {
          this.addLocationEndTwo();
        }

        if(data == 'waiting') {
          this.waitingAdd();
        }

        if(data == 'maintance') {
          this.maintanceAdd();
        }

        if(data == 'washing') {
          this.washAdd();
        }

        if(data == 'adr') {
          this.adrAdd();
        }

        if(data == 'problem') {
          this.problemAdd();
        }

        if(data == 'others') {
          this.othersAdd();
        }

        if(data == 'sleep') {
          this.sleepAdd();
        }

        if(data == 'costcenter') {
          this.addCostCenter();
        }

        if(data == 'help') {
          this.helpAdd();
        }
      }
    });
    alert.present();
  }

  startAddTwo() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Arbeitsbeginn einbuchen');


    alert.addInput({
      type: 'time',
      label: 'Arbeitsstart',
      value: 'start',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] != 'start') {
          this.teamappProvider.http_request('action=add_manual&manual_type=start_two&location='+this.choosenLocation+'&manual_start='+this.times.date+' '+data[0], 'webfleet', false).then(res => {
            this.showSuccess('Der Schichtstart wurde eingetragen:<br><br><b>'+data[0]+'</b>');
            this.navCtrl.pop();
          });
        } else {
          this.startAddTwo();
        }
      }
    });
    alert.present();
  }

  startAdd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Arbeitsbeginn einbuchen');


    alert.addInput({
      type: 'time',
      label: 'Arbeitsstart',
      value: 'start',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] != 'start') {
          this.teamappProvider.http_request('action=add_manual&manual_type=start&location='+this.choosenLocation+'&manual_start='+this.times.date+' '+data[0], 'webfleet', false).then(res => {
            this.showSuccess('Der Schichtstart wurde eingetragen:<br><br><b>'+data[0]+'</b>');
            this.navCtrl.pop();
          });
        } else {
          this.startAdd();
        }
      }
    });
    alert.present();
  }

  helpAdd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Einarbeitung einbuchen');


    alert.addInput({
      type: 'time',
      label: 'Start der Einarbeitung',
      value: 'start',
    });
    alert.addInput({
      type: 'time',
      label: 'Ende der Einarbeitung',
      value: 'end',
    });

    alert.addInput({
      type: 'text',
      label: 'Mitarbeiter',
      placeholder: 'Mitarbeiter',
      value: '',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] != 'start' && data[1] != 'end' && data[2] != '') {
          this.teamappProvider.http_request('action=add_manual&manual_type=help&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1]+'&manual_comment='+data[2], 'webfleet', false).then(res => {
            this.showSuccess('Die Einarbeitung wurde eingetragen:<br><br><b>'+data[0]+'</b>');
            this.navCtrl.pop();
          });
        } else {
          this.helpAdd();
        }
      }
    });
    alert.present();
  }

  sleepAdd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Übernachtung einbuchen');


    alert.addInput({
      type: 'time',
      label: 'Start der Übernachtung',
      value: 'start',
    });
    alert.addInput({
      type: 'time',
      label: 'Ende der Übernachtung',
      value: 'end',
    });
    alert.addInput({
      type: 'text',
      label: 'Ort',
      placeholder: 'Ort',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] != 'start' && data[1] != 'end') {
          this.teamappProvider.http_request('action=add_manual&manual_type=sleep&location='+data[2]+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Die Übernachtung wurde eingetragen:<br><br><b>'+data[0]+'</b>');
            this.navCtrl.pop();
          });
        } else {
          this.sleepAdd();
        }
      }
    });
    alert.present();
  }

  alertCostCenter() {
    const prompt = this.alertCtrl.create({
      title: 'Warnung',
      message: "Für den gewählten Tag wurden keine Kostenstellen verbucht. Soll eine Kostenstelle eingebucht werden?",
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Kostenstelle einbuchen',
          handler: data => {
            this.addCostCenter();
          }
        },
        {
          text: 'Schichtende Buchen',
          handler: data => {
            console.log('Saved clicked');
            this.checkEndBreak();
          }
        }
      ]
    });
    prompt.present();
  }

  checkEndBreak() {
    if(this.times.break_minutes < 30) {
      const prompt = this.alertCtrl.create({
        title: 'Pausen',
        message: "Du hast keine 30 Minuten Pause, wenn du jetzt ein Schichtende buchst, werden automatisch 30 Minuten abgezogen!",
        buttons: [
          {
            text: 'Abbrechen',
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Pause einbuchen',
            handler: data => {
              this.breakAdd()
            }
          },
          {
            text: 'Schichtende Buchen',
            handler: data => {
              console.log('Saved clicked');
              this.addLocationEnd();
            }
          }
        ]
      });
      prompt.present();
    } else {
      this.addLocationEnd();
    }
  }

  endAdd() {
      let alert = this.alertCtrl.create();
      alert.setTitle('Arbeitsende einbuchen');
      alert.addInput({
        type: 'time',
        label: 'Arbeitsende',
        value: 'end',
      });
      alert.addButton('Abbrechen');
      alert.addButton({
        text: 'Weiter',
        handler: data => {
          if(data[0] != 'end') {
            this.teamappProvider.http_request('action=add_manual&manual_type=end&location='+this.choosenLocation+'&manual_end='+this.times.date+' '+data[0], 'webfleet', false).then(res => {
              let resData: any = res;
              if(resData.success == true) {
                this.showSuccess('Das Schichtende wurde eingetragen:<br><br><b>'+data[0]+'</b>');
                this.navCtrl.pop();
              } else {
                this.showError(resData.message);
              }

            });
          } else {
            this.endAdd();
          }
        }
      });
      alert.present();
  }

  endAddTwo() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Arbeitsende einbuchen');
    alert.addInput({
      type: 'time',
      label: 'Arbeitsende',
      value: 'end',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] != 'end') {
          this.teamappProvider.http_request('action=add_manual&manual_type=end_two&location='+this.choosenLocation+'&manual_end='+this.times.date+' '+data[0], 'webfleet', false).then(res => {
            let resData: any = res;
            if(resData.success == true) {
              this.showSuccess('Das Schichtende wurde eingetragen:<br><br><b>'+data[0]+'</b>');
              this.navCtrl.pop();
            } else {
              this.showError(resData.message);
            }
          });
        } else {
          this.endAddTwo();
        }
      }
    });
    alert.present();
  }

  problemAdd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Problemzeit einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Problemzeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Problemzeit',
      value: 'end',
    });

    alert.addInput({
      type: 'text',
      label: 'Kommentar / Grund',
      value: '',
      placeholder: 'Kommentar / Grund',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Problemzeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          this.teamappProvider.http_request('action=add_manual&manual_type=problem&manual_comment='+data[2]+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Das Problem wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b><br>'+data[2]);
            this.navCtrl.pop();
          });
          console.log("try to add manual waiting");
          console.log(data);
        }

      }
    });
    alert.present();
  }

  waitingAdd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Wartezeit einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Wartezeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Wartezeit',
      value: 'end',
    });

    alert.addInput({
      type: 'text',
      label: 'Kommentar / Grund',
      value: '',
      placeholder: 'Kommentar / Grund',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Wartezeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          this.teamappProvider.http_request('action=add_manual&manual_type=waiting&manual_comment='+data[2]+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Die Wartezeit wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b><br>'+data[2]);
            this.navCtrl.pop();
          });
          console.log("try to add manual waiting");
          console.log(data);
        }

      }
    });
    alert.present();
  }

  maintanceAdd() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Werkstattzeit einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Werkstattzeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Werkstattzeit',
      value: 'end',
    });

    alert.addInput({
      type: 'text',
      label: 'Kommentar / Grund',
      placeholder: 'Kommentar / Grund',
      value: '',
    });


    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Werkstattzeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          let tmpData = data;
          const prompt = this.alertCtrl.create({
            title: 'Werkstattzeit',
            message: "Ist die Pause unbezahlt?",
            buttons: [
              {
                text: 'Ja',
                handler: twoData => {
                  this.teamappProvider.http_request('action=add_manual&manual_type=maintance&manual_comment='+data[2]+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1]+'&payable=-1', 'webfleet', false).then(res => {
                    this.showSuccess('Die Zeit wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b><br>'+data[2]);
                    this.navCtrl.pop();
                  });
                }
              },
              {
                text: 'Nein',
                handler: twoData => {
                  this.teamappProvider.http_request('action=add_manual&manual_type=maintance&manual_comment='+data[2]+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1]+'&payable=0', 'webfleet', false).then(res => {
                    this.showSuccess('Die Zeit wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b><br>'+data[2]);
                    this.navCtrl.pop();
                  });
                }
              }
            ]
          });
          prompt.present();


          console.log("try to add manual waiting");
          console.log(data);
        }

      }
    });
    alert.present();
  }

  othersAdd() {

    let alert = this.alertCtrl.create();
    alert.setTitle('Andere Zeit einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Zeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Zeit',
      value: 'end',
    });

    alert.addInput({
      type: 'text',
      label: 'Kommentar / Grund',
      placeholder: 'Kommentar / Grund',
      value: '',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Zeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          this.teamappProvider.http_request('action=add_manual&manual_type=others&manual_comment='+data[2]+'&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Die Zeit wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b><br>'+data[2]);
            this.navCtrl.pop();
          });
          console.log("try to add manual waiting");
          console.log(data);
        }

      }
    });
    alert.present();

  }

  adrAdd() {

    let alert = this.alertCtrl.create();
    alert.setTitle('ADR Einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Zeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Zeit',
      value: 'end',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Zeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          this.teamappProvider.http_request('action=add_manual&manual_type=adr&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Der ADR Zuschlag wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b>');
            this.navCtrl.pop();
          });
          console.log("try to add manual adr");
          console.log(data);
        }

      }
    });
    alert.present();

  }

  washAdd() {

    let alert = this.alertCtrl.create();
    alert.setTitle('Waschzeit einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Zeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Zeit',
      value: 'end',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Zeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          this.teamappProvider.http_request('action=add_manual&manual_type=washing&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Die Waschzeit wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b>');
            this.navCtrl.pop();
          });
          console.log("try to add manual waiting");
          console.log(data);
        }

      }
    });
    alert.present();

  }

  breakAdd() {

    let alert = this.alertCtrl.create();
    alert.setTitle('Unbezahlte Pause einbuchen');

    alert.addInput({
      type: 'time',
      label: 'Anfang der Zeit',
      value: 'start',
    });

    alert.addInput({
      type: 'time',
      label: 'Ende der Zeit',
      value: 'end',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(data[0] > data[1]) {
          this.showError('Das Ende einer Zeit kann nicht vor dem Anfang liegen!');
        } else if(data[0] == 'start' || data[1] == 'end') {
          this.showError('In beiden Feldern muss ein Datum angegeben werden!');
        } else {
          this.teamappProvider.http_request('action=add_manual&manual_type=break&manual_start='+this.times.date+' '+data[0]+'&manual_end='+this.times.date+' '+data[1], 'webfleet', false).then(res => {
            this.showSuccess('Die unbezahlte Pause wurde erfolgreich angelegt:<br><br><b>'+data[0]+' - '+data[1]+'</b>');
            this.navCtrl.pop();
          });
          console.log("try to add manual waiting");
          console.log(data);
        }

      }
    });
    alert.present();
  }

  showSuccess(message: string) {
    const alert = this.alertCtrl.create({
      title: 'Erledigt!',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  showError(message: string) {
    const alert = this.alertCtrl.create({
      title: 'Fehler!',
      subTitle: message,
      buttons: ['OK']
    });
    alert.present();
  }

  deleteWork(work: any) {
    const prompt = this.alertCtrl.create({
      title: 'Einbuchung löschen',
      message: "Du kannst Einbuchungen bis zur 48. Stunden nach dem Eintragen löschen. <br><br><b>Möchtest Du diesen Eintrag löschen?</b>",
      buttons: [
        {
          text: 'Nein',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Ja, löschen',
          handler: data => {
            this.teamappProvider.http_request('action=delete_manual&manual_id='+work.id, 'webfleet', false).then(res => {
              this.showSuccess('Die Position wurde erfolgreich gelöscht!');
              this.navCtrl.pop();
            });
          }
        }
      ]
    });
    prompt.present();
  }

  hasCostcenterComment(inner:any) {
    if(this.coastCenter) {
      for(let i = 0; i<this.coastCenter.length;i++) {
        if (this.coastCenter[i].inner == inner) {
          return this.coastCenter[i].comment_able;
        }
      }
    }
  }
  getCostcenterName(inner:any) {
    if(this.coastCenter) {
      for(let i = 0; i<this.coastCenter.length;i++) {
        if (this.coastCenter[i].inner == inner) {
          return this.coastCenter[i].name;
        }
      }
    }
  }

  countCostCenter() {
    let c = 0;
    if(this.times.works) {
      for(let i = 0; i < this.times.works.length; i++) {
        if(this.times.works[i].pos_type == 'manual_costcenter') {
          c++;
        }
      }
    }
    return c;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WebfleetReportPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/webfleet-report/webfleet-report.ts